// src/components/Admin/AdminDashboard.js
import React from 'react';
import { Link } from 'react-router-dom';

function AdminDashboard() {
  const containerStyle = {
    padding: '30px',
    maxWidth: '900px',
    margin: '30px auto',
    backgroundColor: '#ffffff',
    borderRadius: '10px',
    boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
    textAlign: 'center',
  };

  const headingStyle = {
    color: '#333',
    marginBottom: '30px',
    fontSize: '2.5em',
    borderBottom: '2px solid #007bff',
    paddingBottom: '15px',
    display: 'inline-block', // To make border-bottom fit content
  };

  const navGridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '25px',
    marginTop: '30px',
  };

  const navCardStyle = {
    backgroundColor: '#f8f9fa',
    border: '1px solid #e9ecef',
    borderRadius: '8px',
    padding: '25px',
    textDecoration: 'none',
    color: '#343a40',
    fontSize: '1.2em',
    fontWeight: 'bold',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '150px',
    boxShadow: '0 2px 5px rgba(0,0,0,0.05)',
    ':hover': {
      transform: 'translateY(-5px)',
      boxShadow: '0 8px 20px rgba(0,0,0,0.15)',
      backgroundColor: '#e2e6ea',
    },
  };

  const iconStyle = {
    fontSize: '3em',
    marginBottom: '15px',
    color: '#007bff',
  };

  return (
    <div style={containerStyle}>
      <h1 style={headingStyle}>Admin Dashboard</h1>
      <p style={{ color: '#555', fontSize: '1.1em' }}>
        Welcome to your administration panel. Select a section to manage your data.
      </p>

      <div style={navGridStyle}>
        <Link to="/admin/properties" style={navCardStyle}>
          <span style={iconStyle}>🏠</span> {/* Placeholder icon */}
          Manage Properties
        </Link>
        <Link to="/admin/locations" style={navCardStyle}>
          <span style={iconStyle}>📍</span> {/* Placeholder icon */}
          Manage Locations
        </Link>
        <Link to="/admin/project-names" style={navCardStyle}>
          <span style={iconStyle}>🏗️</span> {/* Placeholder icon */}
          Manage Project Names
        </Link>
      </div>
    </div>
  );
}

export default AdminDashboard;